import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.dashboard');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-dashboard',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.dashboard/view.scss */
/* src/app/page.dashboard/view.scss: no such file or directory */`],
})
export class PageDashboardComponent implements OnInit {
    public stats: any[] = [];
    public recentItems: any[] = [];
    public loading: boolean = true;
    public quickSearch: string = "";
    public featuredCategories: string[] = [
        "간행도서",
        "학술자료집",
        "독도·동해",
        "역사교육",
        "홍보콘텐츠",
        "기타자료"
    ];

    constructor(@Inject( Service) public service: Service) { }

    public ngOnInit() {
        location.replace('/home');
    }

    public async load() {
        this.loading = true;
        await this.service.render();

        const { code, data } = await wiz.call("overview");
        if (code === 200) {
            this.stats = data.stats || [];
            this.recentItems = data.recent || [];
        }

        this.loading = false;
        await this.service.render();
    }

    public statusLabel(status: string) {
        switch (status) {
            case 'published': return '공개';
            case 'draft': return '임시저장';
            case 'archived': return '보관';
            default: return status || '-';
        }
    }

    public statusClass(status: string) {
        switch (status) {
            case 'published': return 'bg-green-50 text-green-700 border border-green-200';
            case 'draft': return 'bg-amber-50 text-amber-700 border border-amber-200';
            case 'archived': return 'bg-slate-100 text-slate-600 border border-slate-200';
            default: return 'bg-slate-100 text-slate-600 border border-slate-200';
        }
    }

    public goSearch(category: string = "") {
        const params = new URLSearchParams();
        const text = (this.quickSearch || "").trim();
        if (text) params.set("text", text);
        if (category) params.set("category", category);

        const query = params.toString();
        this.service.href(`/home${query ? `?${query}` : ""}`);
    }
}

export default PageDashboardComponent;